import posthog from "posthog-js";

const isDev = process.env.NODE_ENV === "development";
// Permite desativar localmente adicionando REACT_APP_DISABLE_POSTHOG_LOCAL=true no arquivo .env
const disableLocal = isDev && process.env.REACT_APP_DISABLE_POSTHOG_LOCAL === "true";

if (process.env.REACT_APP_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    enableExceptionAutocapture: true,
    person_profiles: "identified_only",
    // Se estiver definido para desativar localmente, ativa o opt-out padrão (não envia nenhum evento)
    opt_out_capturing_by_default: disableLocal,
    loaded: (ph) => {
      if (isDev) {
        if (disableLocal) {
          console.log("🔌 [PostHog] Inicializado no modo OPT-OUT (Desativado localmente). Nenhum evento será enviado.");
        } else {
          ph.debug(); // Habilita o console de depuração automática do PostHog localmente
          console.log("⚡ [PostHog] Inicializado em modo DEBUG. Eventos estão sendo enviados.");
        }
      }
    },
  });
} else {
  if (isDev) {
    console.warn("⚠️ [PostHog] REACT_APP_PUBLIC_POSTHOG_KEY não configurada no arquivo .env.");
  }
}

export default posthog;

